import { showToast } from "./toast";

(function attachAlertPatch() {
    if (typeof window === "undefined") return;
    if (window.__BUGLOG_ALERT_PATCH__) return;
    window.__BUGLOG_ALERT_PATCH__ = true;

    const nativeAlert = window.alert.bind(window);

    window.alert = function (message) {
        try {
            const msg = message == null ? "" : String(message);
            const lower = msg.toLowerCase();
            const isError =
                lower.includes("hata") ||
                lower.includes("başarısız") ||
                lower.includes("error") ||
                lower.includes("failed");

            showToast({
                title: isError ? "Hata" : "Bilgi",
                description: msg,
                variant: isError ? "error" : "success",
                duration: 2400
            });
        } catch (e) {
            nativeAlert(message);
        }
    };
})();
